import type { NumberSettings, NumberFormat } from '../types';
import { FORMATS_SUPPORTED_FRACTION_OVERRIDES } from '../constants';

export const needsOverrideMinimumFractionDigits = (
    format: NumberFormat,
    settings: NumberSettings,
    minimumFractionDigits?: number | undefined,
): minimumFractionDigits is number => {
    if (!FORMATS_SUPPORTED_FRACTION_OVERRIDES.has(format)) return false;

    return (
        minimumFractionDigits !== undefined &&
        minimumFractionDigits !== settings.minimumFractionDigits
    )
};
